import { render, staticRenderFns } from "./ContractsList.vue?vue&type=template&id=61dc27cd"
import script from "./ContractsList.vue?vue&type=script&lang=js"
export * from "./ContractsList.vue?vue&type=script&lang=js"
import style0 from "./ContractsList.vue?vue&type=style&index=0&id=61dc27cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports